<template>
  <div class="detailDialog">
      <van-dialog v-model="show" title="详情"  :before-close='confirm' >
        <div v-for="(item,index) in dataInit" :key="index" class="item">
            <div class="item" >
                <span>{{item.label}}</span>：
                <span>{{list[item.value]}}</span>
            </div>
        </div>
    </van-dialog>
  </div>
</template>

<script>
export default {
    props:['show','list','showRoadName'],
    data() {
        return {
            dataInit:[
                {label:'缴费二维码',value:'roadName'},
                {label:'缴费时间',value:'confirmDate'},
                {label:'缴费金额',value:'paymentTotal'},
                {label:'缴费类型',value:'tradingType'},
            ],

        }
    },
    created() {
        this.initData();
    },
    methods:{
        initData() {
            if (this.showRoadName == false) {
                this.dataInit = [{label:'缴费时间',value:'confirmDate'},
                                {label:'缴费金额',value:'paymentTotal'},
                                {label:'缴费类型',value:'tradingType'},]
            }
        },
        confirm(action, done) {
            done(false)
            this.$emit('confirm',action, done)
        }
    }
}
</script>

<style lang='scss' scoped>
.detailDialog {
   ::v-deep .van-dialog__header {
            background: #7fdcad;
            color: #fff;
            padding: 10px 0 !important;
            font-weight: 600 !important;
        }
}
    .item {
        margin-top: 10px;
        >span {
            display: inline-block;
        }
        >span:nth-of-type(1) {
            text-align: right;
             width: 30%;
        }
        >span:nth-of-type(2) {
            text-align: left;
             width: 60%;
        }
    }
</style>